import { BffApiClientMolecule } from "@/app/api-client/store"
import { BlockchainFiltersMoleculeReatom as BlockchainFiltersMolecule } from "@/app/blockchains/filters/blockchain-filters-molecule.reatom"
import { computed } from "@reatom/core"
import { molecule } from "bunshi"
import { getBrandsQueryParams } from "./get-brands-query-params"

export const BrandsMoleculeReatom = molecule((mol) => {
  const bffApiClient = mol(BffApiClientMolecule)
  const { selectedBlockchain } = mol(BlockchainFiltersMolecule)

  const brandsQueryParamsAtom = computed(
    () =>
      getBrandsQueryParams(bffApiClient, {
        blockchain: selectedBlockchain(),
      }),
    "brandsQueryParamsAtom",
  )

  return {
    brandsQueryParamsAtom,
  }
})

// New molecule for brand pages that always uses "ALL" blockchain
export const BrandPageMoleculeReatom = molecule((mol) => {
  const bffApiClient = mol(BffApiClientMolecule)

  const brandsQueryParamsAtom = computed(
    () =>
      getBrandsQueryParams(bffApiClient, {
        blockchain: "ALL",
      }),
    "brandsQueryParamsAtom",
  )

  return {
    brandsQueryParamsAtom,
  }
})
